import * as React from "react";

/**
 * Default view to render whenever a runtime error occurs.
 * TODO: Make nice for user
 */
const RuntimeError: React.SFC = () => (
  <div className="runtime-error">Something unexpected has happened</div>
);

export default RuntimeError;



// WEBPACK FOOTER //
// ./src/components/RuntimeError.tsx